type AnalyticsPageDataset = Readonly<{
  analyticsEnabled?: string;
  analyticsSource?: string;
  analyticsTrafficType?: string;
  analyticsVersion?: string;
  releaseVersion?: string;
}>;

type AutomationSignals = Readonly<{
  webdriver?: boolean;
}>;

export type AnalyticsTrafficContext = Readonly<{
  enabled: boolean;
  source: string;
  trafficType: string;
  version: string;
}>;

export function analyticsTrafficContext(
  dataset: AnalyticsPageDataset,
  automationSignals: AutomationSignals,
): AnalyticsTrafficContext {
  const automated = automationSignals.webdriver === true;
  const source = dataset.analyticsSource || 'unknown';
  const serverContextComplete = !!(dataset.analyticsSource && dataset.analyticsTrafficType && dataset.analyticsVersion);
  const trafficType = automated ? 'automation' : dataset.analyticsTrafficType || 'unknown';
  const version = dataset.analyticsVersion || 'unknown';

  return {
    enabled: dataset.analyticsEnabled === 'true' && serverContextComplete && !automated,
    source,
    trafficType,
    version,
  };
}

export const ANALYTICS_CONFIG_ELEMENT_ID = 'analytics-config';

function analyticsConfigDataset(): AnalyticsPageDataset {
  return document.getElementById(ANALYTICS_CONFIG_ELEMENT_ID)?.dataset ?? {};
}

export function browserAnalyticsTrafficContext(): AnalyticsTrafficContext {
  return analyticsTrafficContext(analyticsConfigDataset(), window.navigator);
}

// The Heroku release serving this page ("v3956"), as a number for analytics. Rails renders it per
// request because a build cannot know it: Heroku numbers the release only after the build.
export function releaseVersion(dataset: AnalyticsPageDataset): number | string | null {
  const value = dataset.releaseVersion;
  if (!value) return null;
  return Number(value.replace(/^v/, '')) || value;
}

export function browserReleaseVersion(): number | string | null {
  return releaseVersion(analyticsConfigDataset());
}

export function shouldUseCrawlerRendering(dataset: AnalyticsPageDataset): boolean {
  return dataset.analyticsTrafficType === 'crawler';
}

export function browserShouldUseCrawlerRendering(): boolean {
  return shouldUseCrawlerRendering(analyticsConfigDataset());
}
